import {countMap} from "./lib/tools";

export const questions = [
  // {
  //   question: "Flot ankomst til gæsterne?",
  //   back: "Niveauet for din fest hæves når gæsterne føler at der tages godt imod dem.",
  //   section: 4,
  //   inside: false,
  //   products: [{productId: 2012, qty: 1}],
  //   btnText: "This is a button",
  //   type: "uppsale",
  //   load: ["loadPartyInfo"],
  //   show: ({partyInfo}) => partyInfo.guests > 9
  // },
  // {
  //   question: "Hvor skal gæsternes overtøj være?",
  //   back: "Undgå kaos med gæsternes overtøj, både når de kommer, og når de skal finde deres tøj, når de skal hjem.",
  //   section: 6,
  //   inside: false,
  //   products: [{productId: 5028, qty: 1}],
  //   type: "uppsale",
  //   load: ["loadPartyInfo"],
  //   show: ({partyInfo}) => partyInfo.guests > 19
  // },
  // {
  //   question: "Gæsterne kommer ikke på samme tid, så giv gæsterne en drink og snacks efterhånden som de ankommer.",
  //   back: "Nogle gæster kommer 5 minutter føt, og andre 10-15 minutter senere. Ventetiden kan være lang, og small talk startes bedst med et glas i hånden. Der er et utal af velkomstdrinks og kombinationsmuligheder. Lige fra friske frugt safte, over champagne,  spiritus,  martinier, til en håndbajer eller en bowle. Husk at have alkoholfrie alternativer til dem der ønsker det. Se inspiration til velkomst og snacks på festen.dk/velkomstartikel200",
  //   section: 2,
  //   inside: false,
  //   products: [{productId: 910, qty: 2}, {productId: 578, qty: 2}, {productId: 576, qty: 2}],
  //   type: "uppsale",
  //   load: [],
  //   show: () => true
  // },
  {
    question: "Vand er den uundværlige vin...",
    back: "Vand og dansk vand ER uundværlige drikkevarer under spisningen.  Vinen flyder bare bedre, når den ledsages af vand, og så nedsætter rigeligt med vand risikofor tømmermænd.  Husk derfor karafler eller kander med vand... og isterninger.",
    inside: true,
    section: 2,
    products: [{productId: 5473, qty: 1}],
    type: "uppsale",
    load: ["cartProducts"],
    show: ({cartProducts}) => countMap(cartProducts, x => x.product.productType === 68 ? 1 : 0) < 1
  },
  {
    question: "Fester du i lys eller mørke?",
    back: "For lidt og for meget... forestil dig at skulle gå igennem en horrorfilm i fuld dagslys eller ligefrem i spotlys. Det vil ikke virke. Ligeledes kan du sætte stemningen under festen ved at bruge garvet lys op ad væggev og på loftet. Lyset i sag selv kan nærmest udgøre oppyntningen, eller i hvert fald en stor del af den.",
    inside: true,
    section: 3,
    products: [{productId: 7538, qty: 1}],
    type: "uppsale",
    load: ["cartProducts"],
    show: ({cartProducts}) => countMap(cartProducts, x => x.product.productType === 86 ? 1 : 0) < 1
  },
  // {
  //   question: "En god afslutning på festen?",
  //   back: "Overordnet, så får alting jo en ende. Og når det drejer sig om fester, så bør de slutte når det lige går allerbedst. Så husker alle tilbage på en super oplevelse. Mange laver den fejl, at de fortsætter for længe, og dermed begynder nogle af gæsterne at sive. Når festen starter og der bydes velkommen, så oplys samtidig gæsterne om planen for aftenen, både hvad, hvornår og hvordan. Oplys også at kl. xx (cirka 7-8 timer efter ankomst) vil der blive serveret \"natmad\" / \"skrub af mad\". Dette sætter et punktum for en god fest, og alle bliver for at få det hele med.",
  //   section: null,
  //   inside: false,
  //   products: [{productId: 5835, qty: 1}],
  //   type: "uppsale",
  //   load: ["loadPartyInfo"],
  //   show: ({partyInfo}) => partyInfo.guests > 9
  // },
  //Question cards
  // {
  //   question: "Ved du hvordan du skaber en fest i en liga der er højere end hvad alle andre gør?",
  //   back: "Tænk dig hvis der kom besøg af Bryan Rice, Nabiha, Barbara Moleko eller en anden kendt kunstner... ? Blot 30 minutters indslag sparker r... - og sætter aftenen i et helt andet perspektiv. Dyrt.... ? - ja gud er det dyrt, - men hvis ikke du har overvejet det, undersøgt det, og vurderet på det, ja, så har du heller ikke gjort dig selv den tjeneste at overveje ALT, for at få den bedste fest nogensiden. Så kik på det, og måske du alligevel finder det værd at tage med i overvejelserne.",
  //   section: 5,
  //   inside: false,
  //   type: "question",
  //   load: ["cartProducts", "loadPartyInfo"],
  //   show: ({partyInfo, total}) => partyInfo.guests > 19 && total > 10000,
  //   link: "/"
  // },
  // {
  //   question: "Mad udefra?",
  //   back: "Vil du slippe for at forberede maden i flere dage op til festen, så overvej at få maden udefra, eller få en kok til at komme og lave maden på selve dagen. En GODT planlagt fest har også større mulighed for at blive godt udført, og husket af gæsterne i mange år.",
  //   section: 1,
  //   inside: false,
  //   type: "question",
  //   load: ["cartProducts", "loadPartyInfo"],
  //   show: ({cartProducts, partyInfo}) => countMap(cartProducts, x => x.section === 9 ? 1 : 0) < 1,
  //   link: "/minfest/mad"
  // },
  // {
  //   question: "Alkoholfrie gæster... de bliver også tørstige..",
  //   back: "Flere og flere efterspørger alkoholfrie alternativer til velkomstdrikke, vinene under spisningen og som drinks senere. Undgå at skuffe nogle, og køb lidt forskellige alkoholfrie drikkevarer: vine med bobler, hvid og rød -vine, sirups og andet til drinks.",
  //   inside: true,
  //   section: 2,
  //   type: "question",
  //   load: ["loadPartyInfo"],
  //   show: ({partyInfo}) => partyInfo.guests > 14
  // }
];

export const infoCards = [
  // Info cards
//   {
//     title: "Pause efter spisningen.. nej tak, - men hvad så?",
//     text: "Stemningen under spisningen slutter ofte på et højt niveau, så for ikke at ødelægge denm så må der ikke opstå en tom pause. Start straks med det næste.",
//     section: 1,
//     guests: 20,
//     type: "info",
//     image: 15440,
//     load: ["loadPartyInfo"],
//     show: ({partyInfo}) => partyInfo.guests > 20
//   },
//   {
//     title: "Vil du have nogle til at sørge for musikken efter spisningen?",
//     text: "Efter spisningen er stemningen og musikken afgørende for at holde \"godt gang i festen\". Hvis du vælger en \"forkert\" playliste fra Spotify, som ikke lige rammer plet, i forhold til hvad der betragtes som \"god\" dansemusik, så er de timer næsten pinlige og bliver bare en periode som for en del af gæsterne \"bare skal overståes\".",
//     section: 4,
//     guests: 20,
//     type: "info",
//     image: 15440,
//     load: ["cartProducts", "loadPartyInfo"],
//     show: ({cartProducts, partyInfo}) => countMap(cartProducts, x => x.section === 15 ? 1 : 0) < 1 && partyInfo.guests > 9
//   }
];


// WEBPACK FOOTER //
// ./src/questions.js